import { NgModule } from '@angular/core';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ResetPasswordComponent } from '../../components/reset-password/reset-password.component';
import { AppRouting } from '../routing';
import { AppComponent } from '../../components';
import * as firebase from 'firebase/app';
import 'firebase/performance';
import 'firebase/analytics';
import { getPerformance } from 'firebase/performance';
import { getAnalytics } from 'firebase/analytics';
import { SharedModule } from './shared.module';
import { UiModule } from './ui.module';
import { environment } from 'src/environments';

@NgModule({
  declarations: [
    AppComponent,
    ResetPasswordComponent,
  ],
  imports: [
    AppRouting,
    UiModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule.forRoot(),
    AngularSvgIconModule.forRoot()
  ],
  exports: [
    UiModule,
    BrowserModule,
    BrowserAnimationsModule
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: {overlayPanelClass: 'mat-form-field-select'}
    },
  ]
})
export class AppModule {
  constructor() {
    const processorApp = firebase.initializeApp(environment.firebaseConfig);
    getPerformance(processorApp);
    getAnalytics(processorApp);
  }
}
